import { Component, Input, OnInit } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'acc-guideline-description',
    standalone: false,
    template: `
        <span class="fas fa-book" aria-hidden="true"></span>
        <span>{{ guidelineDescription }}</span>
    `,
})
export class AccGuidelineDescriptionComponent implements OnInit {
    @Input() check: any;

    guideline: any;
    guidelineDescription: string = '';

    constructor (
        private ng2SessionService: SessionService,
        private translateService: TranslateService,
    ) {}

    ngOnInit () {
        this.guideline = this.getAccessibilityGuideline();
        this.guidelineDescription = this.getHelpCenterGuidelineDescription();
    }

    private getAccessibilityGuideline () {
        return this.ng2SessionService.domain && this.ng2SessionService.domain.features.accessibility;
    }

    private getHelpCenterGuidelineDescription (): string {
        return this.translateService.getString('Part of success criteria [[checkIssueNumber]]', {
            checkIssueNumber: this.check.issue_number,
        });
    }
}
